"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Table = _styledComponents.default.table.withConfig({
  displayName: "fluffy--Table",
  componentId: "fluffy--ydn81x"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    text-align: left;\n    vertical-align: middle;\n    color: ", ";\n    font-size: ", "px;\n    font-family: ", ";\n"], ["\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    text-align: left;\n    vertical-align: middle;\n    color: ", ";\n    font-size: ", "px;\n    font-family: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[0];
}, function (_a) {
  var theme = _a.theme;
  return theme.fontSizes[1];
}, function (_a) {
  var theme = _a.theme;
  return theme.fonts.generic[5];
});
exports.Table = Table;
var templateObject_1;